class ProductBundle extends HTMLElement{
        constructor() {
            super();
            this.querySelector(".bundle-btn").addEventListener("click", (element) => {
              
              this.querySelector('.bundle-btn').setAttribute('aria-disabled', true);
              this.querySelector('.bundle-btn').classList.add('loading');
              this.querySelector('.bundle-btn .loading-overlay__spinner').classList.remove('hidden');
              
                let $selected_variants_id = [];
                this.querySelectorAll(".bundle-product-card").forEach((e) => {
                  let $variant_id = Number(e.getAttribute("bundle-product-card"));
                  let $Properties_pro = e.dataset.properties;

                  if($Properties_pro){
                      var $pass_param = {'id': $variant_id, 'quantity': 1, 'properties': {'_ItemPostion': $Properties_pro}};
                  }else{
                      var $pass_param = {'id': $variant_id,'quantity': 1};
                  }
                  $selected_variants_id.push($pass_param)
                })
              this.addTocart($selected_variants_id)
            })
        }
        connectedCallback(){}

        addTocart(variants){
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.headers['Content-Type'] = 'application/json';
            // Construct the JSON payload
            const payload = {
                items: variants.map(variant => ({
                    id: variant.id,
                    quantity: variant.quantity,
                    properties: variant.properties ? variant.properties : {}
                }))
            };

            if (this.cart) {
                payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
                payload.sections_url = window.location.pathname;
                this.cart.setActiveElement(document.activeElement);
            }
            config.method = 'POST';
            config.body = JSON.stringify(payload);

            // Send the fetch request
            const response = fetch(`${routes.cart_add_url}`, config)
            .then(response => {
                return response.json();
            }).then((data) => {
                fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
                .then((response) => response.json())
                .then((response) => {
                    let responseFormated = {
                        sections: response
                    }
                    let cart_drawer = document.querySelector('cart-drawer');
                    cart_drawer.renderContents(responseFormated)
                  
                    this.querySelector('.bundle-btn').removeAttribute('aria-disabled', true);
                    this.querySelector('.bundle-btn').classList.remove('loading');
                    this.querySelector('.bundle-btn .loading-overlay__spinner').classList.add('hidden');
                  
                })
                if(document.querySelector("cart-drawer").classList.contains("is-empty")){
                    document.querySelector("cart-drawer").classList.remove("is-empty");
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }

        Allvariants(element){
            let getJsonData = JSON.parse(element.querySelector("script[type='application/json']").innerHTML);
            return getJsonData;
        }

        
    }
customElements.define('product-bundle', ProductBundle);